import Image from "next/image";
import React from "react";
import { PRIMARY_BUTTON_CLASS } from "@/components/Atoms/Buttons/NewPrimaryButton/styles";
import NewHeroDescription from "@/components/Atoms/Typography/NewHeroDescription";
import NewHeroText from "@/components/Atoms/Typography/NewHeroText";
import {
    SIGN_UP_ENDPOINT,
    SURVEY_START_SECTIONS,
} from "@/public/Constants/EnumConstants";
import Link from "next/link";

const Banner = ({ data }) => {
    return (
        <div className={"relative"}>
            <div className={"relative h-auto"}>
                {data?.banner_image?.url && (
                    <div className="relative min-w-screen !w-full aspect-[16/9] hidden md:block">
                        <Image
                            layout="fill"
                            alt={data?.banner_image?.alt || "Banner Image"}
                            src={data?.banner_image?.url}
                            className="object-cover"
                        />
                        {/* Overlay for desktop */}
                        <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-20 z-10" />
                    </div>
                )}

                {data?.mobile_banner_image?.url && (
                    <div className="relative min-w-screen !w-full aspect-[9/16] block md:hidden">
                        <Image
                            fill
                            alt={
                                data?.mobile_banner_image?.alt || "Banner Image"
                            }
                            src={data?.mobile_banner_image?.url}
                            className="object-cover"
                        />
                        {/* Overlay for mobile */}
                        <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-20 z-10" />
                    </div>
                )}
            </div>
            <div
                className={
                    "absolute min-h-[485px] top-0 left-0 h-[100%] w-[100%] text-center flex justify-center !items-center z-20"
                }
            >
                <div
                    className={
                        "grid grid-cols-1 text-center bg-opacity-60 justify-center !items-center align-middle mx-[2%] sm:mx-[15%] md:mx-[16%] lg:mx-[15%] 2xl:mx-[25%] md:my-[8%] xl:my-[12%] 2xl:my-[15%] absolute md:static bottom-[90px] md:bottom-auto"
                    }
                >
                    <NewHeroDescription text={data?.description} />
                    <NewHeroText text={data?.title} />
                    <NewHeroDescription
                        text={data?.tag_line}
                        customStyles={"mx-4"}
                    />
                    {data?.button_text && (
                        <div className={"mt-6 mb-5"}>
                            <Link
                                href={
                                    data?.button_link ||
                                    `${SIGN_UP_ENDPOINT}?from=${SURVEY_START_SECTIONS?.HomeBanner}`
                                }
                                className={PRIMARY_BUTTON_CLASS}
                            >
                                {data?.button_text || "Start The Style Quiz"}
                            </Link>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Banner;
